import ChoicePicker from '../components/ChoicePicker';
import ContinueButtonBar from '../components/ContinueButtonBar';
import type { useEmploymentContractFlow } from './useEmploymentContractFlow';

type Flow = ReturnType<typeof useEmploymentContractFlow>;

export default function EmploymentContractChatComposer({ flow }: { flow: Flow }) {
  if (!flow.awaitingAgree) return null;
  return (
    <div style={{ padding: '12px 16px' }}>
      <ChoicePicker
        value={null}
        options={[
          { value: 'yes', label: flow.msg('yes') },
          { value: 'no', label: flow.msg('no') },
        ]}
        onChange={(v) => void flow.advanceAgree(v)}
      />
    </div>
  );
}

export function EmploymentContractDeclinedComposer({ onContinue }: { onContinue: () => void }) {
  return <ContinueButtonBar onContinue={onContinue} />;
}
